import React from 'react';
import EnterprisePlanSVG from '@birdi/icons/ultimate-plan-2.svg';
import { PlanOption, PaymentIntervalOption } from './plan-option';

interface UltimatePlanOptionProps {
  displayInterval?: PaymentIntervalOption;
}

export const UltimateOption = (props: UltimatePlanOptionProps): JSX.Element => {
  const { displayInterval = 'annual' } = props;

  const features = [
    'Custom no. users & guest seats',
    'Custom no. workspace & storage',
    'Includes processing credit',
    // 'Custom report templates',
    // 'Difference Grid analysis',
    // 'Slope stability prism monitoring',
    // 'Custom WMTS/WMS',
    // 'Asset management',
    // 'Lidar, thermal & multispectral support',
    'Add-ons available',
    // 'Premium support & onboarding'
  ];

  return (
    <PlanOption
      title="Ultimate"
      icon={EnterprisePlanSVG}
      subtitle="For enterprises"
      description="Maximum flexibility, collaboration & customization — for larger organizations managing high volumes of geospatial data with advanced processing needs and tailored workflows across teams."
      headerText="All the Growth plan features plus:"
      features={features}
      themeColor="lightOcean"
      planData={null}
      displayInterval={displayInterval}
      currency="USD"
      customActionButton={{
        url: "https://www.birdi.io/book-a-demo",
        label: "Book a Demo"
      }}
      withHeader="Mid to large businessess"
      annualBillingOnly={true}
    />
  );
};
